// Default SVG marks used when no logo is uploaded to the branding / intake record.
export function MagnaMentesMark({ size = 36, className = "" }) {
  // Bold "M" made of two peaks — mirrors the seeded default SVG.
  return (
    <svg
      viewBox="0 0 200 140"
      width={size}
      height={size}
      className={className}
      aria-label="Magna Mentes logo"
      style={{ display: "block" }}
    >
      <rect width="200" height="140" fill="#0C0C0C" />
      <path
        d="M 30 108 L 30 32 L 50 32 L 100 82 L 150 32 L 170 32 L 170 108 L 152 108 L 152 60 L 108 100 L 92 100 L 48 60 L 48 108 Z"
        fill="#F5F3EE"
      />
      <rect x="30" y="116" width="140" height="4" fill="#FF5A1F" />
    </svg>
  );
}

export function ClientPlaceholderMark({ text = "?", size = 44 }) {
  const initial = String(text || "?").trim().slice(0, 1).toUpperCase() || "?";
  return (
    <div
      className="border-2 border-black bg-[rgb(var(--flame))] grid place-items-center font-display text-lg"
      style={{ width: size, height: size, color: "#0C0C0C" }}
      aria-label={`${text} logo placeholder`}
    >
      {initial}
    </div>
  );
}

// Render a logo (data URL) inside a bordered frame that matches the design language.
export function LogoFrame({ src, alt, size = 44, fallback }) {
  if (src) {
    return (
      <div
        className="border-2 border-black overflow-hidden bg-[rgb(var(--ink))]"
        style={{ width: size, height: size }}
      >
        <img src={src} alt={alt} className="w-full h-full object-contain" />
      </div>
    );
  }
  return fallback || null;
}
